<template>
    <section class="sites-list-stack" :class="{ year: year }" v-if="cards && cards.length > 0">
        <div class="container">
            <header class="component-header" v-if="showHeader">
                <h2 v-html="title" class="headline-1"></h2>
            </header>
            <ul class="stack">
                <li v-for="card in cards" :key="card.id">
                    <CardsArchivedSite type="list" :item="card" />
                </li>
            </ul>
        </div>
    </section>
</template>

<script setup>
    // Props
    const props = defineProps({
        cards: {
            type: Array,
            required: true,
            default: [],
        },
        showHeader: {
            type: Boolean,
            required: false,
            default: true,
        },
        componentLocation: {
            type: String,
            required: false,
            default: '',
        },
        year: {
            type: String,
            required: false,
        },
    });

    const { cards, showHeader, componentLocation } = toRefs(props);

    // Computed
    const total = computed(() => {
        return cards.value.length || 0;
    });

    const title = computed(() => {
        if (componentLocation && componentLocation.value) {
            switch (componentLocation.value.toLowerCase()) {
                case 'neighborhood':
                    return `Sites In This Neighborhood (${total.value})`;
                case 'itinerary':
                    return `Sites On This Itinerary (${total.value})`;
            }
        }
    });
</script>

<style lang="scss" scoped>
    .sites-list-stack {
        padding: 15px 0 30px 0;

        @media (min-width: $tablet) {
            .stack {
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                grid-column-gap: 20px;
                grid-row-gap: 40px;
            }
        }
    }

    .itinerary-detail .sites-list-stack .container {
        padding: 0;
    }
</style>
